import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.button.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-xkxb3p-0"
})(["position:absolute;z-index:10000000;top:18px;right:18px;cursor:pointer;padding-top:", ";> svg{", ";}", ";"], function (_ref) {
  var withPaddingTop = _ref.withPaddingTop;
  return withPaddingTop ? '127px' : '0';
}, function (_ref2) {
  var color = _ref2.color;
  return "color: ".concat(color);
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  top: 15px;\n  right: 15px;\n  "])), function (_ref3) {
  var withPaddingTop = _ref3.withPaddingTop;
  return withPaddingTop ? '167px' : '0';
}));